import { List } from "antd-mobile";
import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import PsContext from "../../context";
import { MOB_ICONS, jsonToQuery, upperCase, yearBySem } from "../../utils";

const TimeTableListItem = (props) => {
  const item = props.data;
  const context = useContext(PsContext);

  const navigate = useNavigate();

  const [redirect, setRedirect] = useState([]);

  const getIcon = () => {
    return item.attendace_marked_count > 0
      ? MOB_ICONS.CHECKMARK_256
      : MOB_ICONS.TIMEMANAGEMENT_256;
  };

  const linkClick = () => {
    if (props.upComing) return;
    //if (!item.entry_type) item.entry_type = "general";
    navigate("/staff/app/attendance-entry?" + jsonToQuery(item));
  };

  return (
    <List.Item
      /* onClick={(e) => linkClick()}*/
      prefix={
        <img
          src={getIcon()}
          className="img-fluid"
          alt=""
          style={{ width: "26px", height: "26px" }}
        />
      }
      extra={
        <span className=" bg-red-50 text-danger px-1 rounded-circle">{`H${item.substitute_hour}`}</span>
      }
    >
      <div style={{ fontSize: "14px" }}>
        <span style={{ fontWeight: "bold" }}>{item.subject_code}</span>
        {" - "}
        {item.substitute_subject_name}{" "}
        {item.short_name ? " - " + item.short_name : ""}
      </div>

      <span style={{ fontSize: "12px" }}>
        {item.degreename}-{item.coursename} - (
        {item.dept_type == "aided" ? "R" : "SF"}) -{yearBySem(item.semester)} -{" "}
        {upperCase(item.section)}
      </span>
      {item.room_id && (
        <div style={{ fontSize: "11px", color: "#1508c9" }}>
          <span className="float-start">{item.block_name}</span>
          <span className="float-end fw-bold">{item.room_name}</span>
        </div>
      )}
      {item.altered_by &&
        upperCase(context.user.employee_name) != upperCase(item.altered_by) && (
          <div style={{ fontSize: "12px", color: "#bd3d00" }}>
            <i>{item.altered_by}</i>
          </div>
        )}
    </List.Item>
  );
};
export default TimeTableListItem;
